import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { withRouter } from 'react-router-dom';
import SocialAccount from './SocialAccountComponent';
import OTPComponent from './OTPComponent';
import OldPassword from './OldPasswordComponent';
import SignInComponent from './SignInComponent';
import { signupSendOTP, signupAuthUser } from '../actions/signupAction';
import { accountCheck, login } from '../actions/signinAction';
import { setReferrerDetails } from '../../myaccount/actions/referAndEarn';
import { hideModal } from '../../actions/modal.js';
import {
  validateMobile,
  validateEmail,
  validateUsername,
  validatePassword
} from '../../utils/inputValidator';
import { readCookie, createCookie } from '../../utils/Cookie';
import { parseSearch } from '../../modules/ajio-util/query';
import cleverTapPushEvent from '../../modules/ajio-util/cleverTap/eventUtils';
import properties from '../../modules/ajio-util/properties';
import CLEVERTAP_EVENT_NAMES from '../../modules/ajio-util/cleverTap/eventConstants';
import { isPhoneUserAgent } from '../../utils/loginUtil';
import { isRilDomain } from '../../utils/common';
import { requestType } from '../../constants/constant.js';
import {
  getReferralFeatureEnableFlag,
  getRefereeEnableFlag,
  getReferralAuthFeedbackTitle,
  getReferralAuthFeedbackSubTitle,
  getReferralCongratulationHeading,
  getReferralCongratulationSubHeading,
  getAjioMassEmailIdOptionalWeb
} from '../../Flags/selectors';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../components/common/CheckUserStatus';
import screen from '../../utils/pageType';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import {
  getUaas,
  getFraudReductionForEmployeeCouponsFlag,
  getFraudReductionForEmpCouponsLabels,
  getAvailableDomainsFlag,
  getRemovalLoginPasswordJson,
  getEnableRestorePhoneNumber,
  getAccountCheckApiErrorMsgForSignup
} from '../../refresh/selectors/featureFlagsSelector';
import FloatingInput from './floating-input';
import luxeScreen from '../../refresh/constants/luxeScreenType';
import { getFeatureVariant } from '../../refresh/organism/ABFeature/Feature';
import { STREET_STORE } from '../../constants/constant';
import EmailVerify from '../../refresh/atoms/EmailVerify';
import readAloudFormErrors from '../../utils/accessibility';

class SignUpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleSendOTPSubmit = this.handleSendOTPSubmit.bind(this);
    this.handleOTPAuthSubmit = this.handleOTPAuthSubmit.bind(this);
    this.state = {
      inputSignUpType: 'text',
      inputPlaceHolder: 'Mobile',
      agreed: false,
      errName: '',
      errGender: '',
      errEmail: '',
      errMob: '',
      errPwd: '',
      errChkbox: '',
      userName: '',
      userEmail: '',
      userGender: '',
      userMobile: '',
      userPwd: '',
      showOTPComponent: false,
      otpEntered: '',
      signUpError: false,
      pwdComponent: false,
      backToAuth: false,
      existingUserSignUp: {},
      showTimer: true,
      showTxt: false,
      showPwdClicked: false,
      hideTxt: false,
      userAccObj: {},
      inviteCode: '',
      errorMsg: '',
      showRilEmailMsg: false
    };
  }

  componentWillMount() {
    let userAccCredInfo = decodeURIComponent(readCookie('uI'));
    if (validateEmail(userAccCredInfo)) {
      this.setState({
        inputSignUpType: 'text',
        inputPlaceHolder: this.props.ajioMassEmailIdOptional ? 'Mobile*' : 'Mobile',
        userEmail: userAccCredInfo
      });
    } else if (validateMobile(userAccCredInfo)) {
      this.setState({
        inputSignUpType: 'email',
        inputPlaceHolder: this.props.ajioMassEmailIdOptional ? 'Email (optional)' : 'Email',
        userMobile: userAccCredInfo
      });
    }
  }

  componentDidMount() {
    const {
      flags = {},
      referrerDetails: { referralCode = '' } = {},
      newDesignLuxe,
      storeName,
      location: { search = '' }
    } = this.props;
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags) && referralCode) {
      this.referralGtmEventPush('Entered referral code auto filled');
      this.setState({ inviteCode: referralCode });
    }
    const { signup: { pageType = '', pageName = '' } = {} } = screen;
    localStorage.setItem('LoginModelType', 'login/signup screen');
    localStorage.setItem('LoginBackButtonType', 'login/signup screen');
    gtmEventPush({
      event: 'form_initiate',
      form_name: 'Sign-up',
      page_type: pageType,
      page_name: 'login/signup screen'
    });
    // Segment Event Push
    segmentEventPush({
      event: 'Login / Signup Initiated',
      form_name: 'Sign-up',      
      screen_name: 'login/signup screen',
      status:''
    });
    const params = new URLSearchParams(search);
    const referrer = params.get('referrer') || '';
    const loginSource = params.get('login_source') || '';
    const { signup = {} } = luxeScreen;
    const { signup: ajioSignup = {} } = screen;
    gtmPagePush(
      'login/signup screen',
      newDesignLuxe ? signup?.pageType || '' : ajioSignup?.pageType || '',
      window.__ENV__ || '',
      {
        Step: 2,
        source: referrer,
        login_source: loginSource,
        store: storeName
      }
    );
  }

  referralGtmEventPush = (label, category = 'bannerimpression') => {
    gtmEventPush({
      event: category,
      event_category: category,
      event_action: 'Signup - referral code',
      event_label: label
    });
  };

  renderReferralHeader = (page = '', newDesignLuxe) => {
    if (
      getReferralFeatureEnableFlag(this.props.flags) &&
      getRefereeEnableFlag(this.props.flags) &&
      this.props.viewSiteAs !== 'desktop'
    ) {
      const { referrerDetails, refereeIncentive } = this.props;
      const { referralCode, referrerName } = referrerDetails;

      if (referralCode) {
        const ajioIcon = `${properties.getProperty('imageBaseUrl')}/static/img/ajio.png`;
        const authHeaderBg = `${properties.getProperty(
          'imageBaseUrl'
        )}/static/img/refresh-auth-bg.png`;
        const desktopStyle =
          this.props.viewSiteAs == 'desktop' ? { backgroundImage: `url(${authHeaderBg})` } : {};
        return (
          <header className="auth-header-new">
            <img className="auth-header-new--ajio-icon" src={ajioIcon} alt="Ajio logo" />
            <h1 style={{ marginBottom: 0 }} className="title">
              {getReferralAuthFeedbackTitle(this.props.flags).replace(
                '_USERNAME_',
                referrerName || 'Your friend'
              )}
            </h1>
            {Number.isInteger(refereeIncentive) && refereeIncentive > 0 ? (
              <h3 className="subtitle">
                {getReferralAuthFeedbackSubTitle(this.props.flags).replace(
                  '_INCENTIVE_',
                  refereeIncentive
                )}
              </h3>
            ) : null}
          </header>
        );
      }
    }
    if (page === 'signupOtp') {
      return <h1>Number Verification </h1>;
    }
    return (
      <h1>
        Welcome to{' '}
        <span className={newDesignLuxe ? 'welcome-text' : ''}>
          {`${newDesignLuxe ? 'AJIO LUXE' : 'AJIO'}`}{' '}
        </span>
      </h1>
    );
  };

  updateReferralCode = () => {
    const { inviteCode = '' } = this.state;
    const { referrerDetails: { referralCode = '' } = {}, setReferrerDetailsObj } = this.props;
    if (this.state.errPwd && this.state.errPwd.includes('code')) {
      this.setState({ errPwd: '' });
    }
    if (referralCode === '' && inviteCode === '') {
      return;
    }
    if (inviteCode !== referralCode) {
      this.referralGtmEventPush('Entered referral code manually', 'buttonTap');
      setReferrerDetailsObj({
        referralCode: inviteCode,
        referrerName: ''
      });
    }
  };

  renderInviteCodeInputError = msg => {
    this.referralGtmEventPush('Entered referral code failed', 'buttonTap');
    return (
      <div id="error-msg" className="error-msg">
        {msg}
      </div>
    );
  };

  renderInviteCodeInput = () => {
    const { newDesignLuxe } = this.props;

    if (getReferralFeatureEnableFlag(this.props.flags) && getRefereeEnableFlag(this.props.flags)) {
      this.referralGtmEventPush('Enter referral code visible to customer');
      return (
        <>
          <div>
            {newDesignLuxe ? (
              <FloatingInput
                floatingText="Invite code (optional)"
                type="text"
                name="inviteCode"
                className="login-form-inputs"
                placeholder="   "
                size="9"
                maxLength="9"
                value={this.state.inviteCode}
                onChange={e => {
                  this.setState({ inviteCode: e.target.value });
                }}
                onBlur={this.updateReferralCode}
              />
            ) : (
              ''
            )}

            {newDesignLuxe ? (
              ''
            ) : (
              <input
                type="text"
                name="inviteCode"
                className="login-form-inputs"
                placeholder="Invite code (optional)"
                size="9"
                maxLength="9"
                value={this.state.inviteCode}
                onChange={e => {
                  this.setState({ inviteCode: e.target.value });
                }}
                onBlur={this.updateReferralCode}
              />
            )}
          </div>
          {this.state.errPwd && this.state.errPwd.includes('code')
            ? this.renderInviteCodeInputError(this.state.errPwd)
            : null}
        </>
      );
    }
    return null;
  };

  setReferralSuccessData = () => {
    const {
      flags = {},
      referrerDetails: { referrerName = '' } = {},
      refereeIncentiveExpiresIn = {},
      refereeIncentive = 0
    } = this.props;
    const { inviteCode } = this.state;
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags) && inviteCode) {
      const { unit = '', value = 0 } = refereeIncentiveExpiresIn;
      if (window.sessionStorage) {
        const userName = referrerName || 'Your friend';
        const incentive = refereeIncentive.toFixed();
        let cashMessage = getReferralCongratulationHeading(flags).replace('_USERNAME_', userName);
        cashMessage = cashMessage.replace('_INCENTIVE_', incentive);
        let expiresInMessage = getReferralCongratulationSubHeading(flags).replace(
          '_DURATION_VALUE_',
          value
        );
        expiresInMessage = expiresInMessage.replace('_DURATION_UNIT_', unit);
        const stringifiedMessageObject = JSON.stringify({ cashMessage, expiresInMessage });
        const encodedMsg = btoa(encodeURIComponent(stringifiedMessageObject));
        window.sessionStorage.setItem('refInc', encodedMsg);
      }
    }
  };

  handleSendOTPSubmit(
    event,
    signUpSendOTPObj,
    viewSiteAs,
    isResendOTP,
    enableRestorePhoneNumber,
    signupEmailExistMessage,
    signupRestoreMessage
  ) {
    event.preventDefault();
    signUpSendOTPObj = {
      ...signUpSendOTPObj,
      mobileNumber: signUpSendOTPObj.mobileNumber,
      requestType: requestType.SENDOTP,
      newDesign: this.props.newDesign
    };
    var accCheckObj = {};
    /* Input Validations */
    let errEmail = '';
    let errPwd = '';
    let errName = '';
    let errGender = '';
    let errMob = '';
    let errChkbox = '';
    if (this.state.inputSignUpType == 'email') {
      if (this.props.ajioMassEmailIdOptional) {
        if (getFeatureVariant('email-is-optional') === '0') {
          if (!validateEmail(this.state.userEmail)) {
            errEmail = 'Please enter a valid Email ID.';
          }
          accCheckObj = { emailId: this.state.userEmail };
        } else {
          if (this.state.userEmail !== '') {
            if (!validateEmail(this.state.userEmail)) {
              errEmail = 'Please enter a valid Email ID.';
            }
          }
          accCheckObj = { mobileNumber: this.state.userMobile };
        }
      } else {
        if (!validateEmail(this.state.userEmail)) {
          errEmail = 'Please enter a valid Email ID.';
        }
        accCheckObj = { emailId: this.state.userEmail };
      }
    } else {
      if (!validateMobile(this.state.userMobile) || this.state.userMobile.length !== 10) {
        errMob = 'Please enter a valid Mobile number.';
      }
      accCheckObj = { mobileNumber: this.state.userMobile };
    }
    if (validateUsername(this.state.userName)) {
      createCookie('un', this.state.userName, 1);
    } else {
      errName = 'Use only alphabets and an optional single space between words.';
    }
    if (!this.state.userGender) {
      errGender = 'Please select Gender';
    }
    // if (
    //   !enableRestorePhoneNumber &&
    //   !validatePassword(this.state.userPwd) &&
    //   !this.props.newDesign
    // ) {
    //   // errPwd = "Use minimum of 6 characters with atleast 1 number.";
    //   errPwd =
    //     'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.';
    // }
    if (!this.state.agreed) {
      errChkbox = 'You must agree to Terms and Conditions';
    }
    if (
      errName == '' &&
      errGender == '' &&
      errPwd == '' &&
      errEmail == '' &&
      errMob == '' &&
      errChkbox == ''
    ) {
      if (!isResendOTP) {
        if (this.state.inviteCode) {
          gtmEventPush({
            page_name: 'login/signup screen',
            page_type: 'Sign Up screen',
            event: 'user_account_interactions',
            category: 'user account interactions',
            action: 'Sign up | Send OTP',
            label: this.state.inviteCode,
            referral_code: this.state.inviteCode
          });
        } else {
          gtmEventPush({
            page_name: 'login/signup screen',
            page_type: 'Sign Up screen',
            event: 'user_account_interactions',
            category: 'user account interactions',
            action: 'Sign up | Send OTP',
            label: 'No code',
            referral_code: 'No code'
          });
        }

        segmentEventPush({
          event: 'SignUp Form Filled',   
          screen_name: 'login/signup screen',        
          gender: this.state.userGender,
          referral_code: this.state.inviteCode
        });
      }
      accCheckObj = { ...accCheckObj, notSetCookie: true };
      this.props.accountCheck(accCheckObj, (checkResponse = {}) => {
        const { success: userExists } = checkResponse;
        const { history = {} } = this.props;
        let existingCred =
          Object.keys(accCheckObj)[0] == 'emailId'
            ? this.state.userEmail
            : `+91 ${this.state.userMobile}`;
        let associatedAcc =
          Object.keys(accCheckObj)[0] == 'emailId'
            ? this.props.maskedMobileNumber
            : this.props.maskedEmailId;
        if (userExists) {
          let existingUserData = {
            existingCred,
            associatedAcc
          };
          this.setState({
            existingUserSignUp: existingUserData
          });
          // show pwd component
          this.setState({
            pwdComponent: true,
            userAccObj: accCheckObj
          });
          if (!enableRestorePhoneNumber) {
            gtmEventPush({
              page_name: 'login/signup screen',
              page_type: 'login/signup',
              event: 'user_account_interactions',
              category: 'user account interactions',
              action: 'formError',
              label: signupEmailExistMessage
            });
          } else {
            gtmEventPush({
              page_name: 'login/signup screen',
              page_type: 'login/signup',
              event: 'user_account_interactions',
              category: 'user account interactions',
              action: 'formError',
              label: signupRestoreMessage
            });
          }
        } else {
          console.log('elseeeee');
          this.props
            .signupSendOTP(signUpSendOTPObj, (serviceRes) => {
              console.log(
                '🚀 ~ file: SignUpComponent.js:422 ~ SignUpComponent ~ .signupSendOTP ~ this.props.statusCode == 1:',
                this.props.statusCode == 1
              );
              if (serviceRes.statusCode == 1) {
                if (serviceRes.message) {
                  this.setState({
                    errorMsg: serviceRes.message,
                    showTimer: false
                  });
                }
                gtmPagePush('signup - otp screen', 'user account screen', window.__ENV__ || '');
                ga('send', {
                  eventCategory: 'Sign Up',
                  eventAction: "Glad you're back",
                  eventLabel: 'Send OTP - Success'
                });
                cleverTapPushEvent({
                  eventName: CLEVERTAP_EVENT_NAMES.User_Sign_Up,
                  eventObj: {
                    source: 'Sign Up Page',
                    type: 'Sign up Via EMail Id and Password',
                    user_id: this.state.userEmail,
                    platform: 'MSITE',
                    Gender: this.state.userGender
                  }
                });
                this.setState({
                  showOTPComponent: true
                });
              }
              if (this.props.errorStatus == 400) {
                this.setState({ signUpError: true });
                ga('send', {
                  eventCategory: 'Sign Up',
                  eventAction: "Glad you're back",
                  eventLabel: 'Send OTP - Failure'
                });
              }
            })
            .catch(({ message }) => {
              this.setState({
                errPwd: message
              });
            });
        }
      });
    }
    const { signup: { pageType = '', pageName = '' } = {} } = screen;
    let typeError = '';
    if (errGender) {
      typeError = 'Gender';
    } else if (errName) {
      typeError = 'Name';
    } else if (errEmail) {
      typeError = 'email';
    } else if (errMob) {
      typeError = 'Mobile';
    } else if (errPwd) {
      typeError = 'password';
    } else if (errChkbox) {
      typeError = 'Terms and Conditions';
    }
    if (errEmail || errName || errGender || errMob || errChkbox) {
      let data = {
        page_name: 'login/signup screen',
        page_type: enableRestorePhoneNumber ? 'login/signup' : pageType,
        event: enableRestorePhoneNumber ? 'user_account_interactions' : 'formError',
        category: enableRestorePhoneNumber ? 'user account interactions' : 'formError',
        label: errGender || errName || errEmail || errMob || errChkbox,
        action: enableRestorePhoneNumber ? 'formError' : 'Sign up form'
      };

      if (!enableRestorePhoneNumber) {
        data.field_name = typeError;
      }

      gtmEventPush(data);
    }

    this.setState({
      errEmail,
      errName,
      errGender,
      errMob,
      errPwd,
      errChkbox
    });
    if (isResendOTP) {
      gtmEventPush({
        page_name: 'signup - otp screen',
        page_type: 'user account screen',
        event: 'user_account_interactions',
        category: 'user account interactions',
        action: 'Resend OTP'
      });
    }
    readAloudFormErrors('.error-msg');
  }

  // Sign Up With OTPComponent
  handleOTPAuthSubmit(event, signUpAuthObj, viewSiteAs) {
    event.preventDefault();
    signUpAuthObj = {
      ...signUpAuthObj,
      requestType: requestType.AUTHUSER,
      newDesign: this.props.newDesign
    };
    signUpAuthObj = { ...signUpAuthObj, otp: this.state.otpEntered };

    this.props.signupAuthUser(signUpAuthObj, serviceRes => {
      if (serviceRes.statusCode === '1') {
        var signInObj = {};
        signInObj = {
          username: signUpAuthObj.login,
          password: signUpAuthObj.password
        };
        const { queryString = '' } = this.props;
        let queryObj = parseSearch(queryString);
        if (this.state.otpEntered != '') {
          if (serviceRes.access_token) {
            const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
            const { signup_otp: { pageType = '', pageName = '' } = {} } = screen;
            gtmEventPush({
              event: 'register_success',
              referral_page: window.location.href,
              user_type: loginStatus,
              login_method: 'OTP',
              page_type: pageType,
              page_name: 'signup - otp screen'
            });
            gtmEventPush({
              Event: 'user_account_interactions',
              Category: 'user_account_interactions',
              user_type: loginStatus,
              login_method: 'OTP',
              page_type: pageType,
              page_name: 'signup - otp screen'
            });
            gtmEventPush({
              event: 'form_submit',
              form_name: 'Sign-up',
              page_type: pageType,
              page_name: 'signup - otp screen'
            });
            if (this.state.inviteCode) {
              gtmEventPush({
                page_name: 'signup - otp screen',
                page_type: 'user account screen',
                event: 'user_account_interactions',
                category: 'user account interactions',
                action: 'Sign up success',
                label: `OTP - ${this.state.inviteCode}`,
                referral_code: this.state.inviteCode
              });
            } else {
              gtmEventPush({
                page_name: 'signup - otp screen',
                page_type: 'signup otp screen',
                event: 'user_account_interactions',
                category: 'user account interactions',
                action: 'Sign up success',
                label: 'OTP - No code',
                referral_code: 'No code'
              });
            }

            // ga('send', {
            //   eventCategory: 'Sign Up',
            //   eventAction: "Glad you're back",
            //   eventLabel: 'Start Shopping - Success'
            // });
            cleverTapPushEvent({
              eventName: CLEVERTAP_EVENT_NAMES.User_Sign_Up,
              eventObj: {
                source: 'Sign Up Page',
                type: 'Sign up Via EMail Id and Password',
                user_id: this.state.userEmail,
                platform: 'MSITE',
                Gender: this.state.userGender
              }
            });
            this.setReferralSuccessData();
            const parentUrl = properties.getProperty(
              this.props.newDesignLuxe ? 'luxeURL' : 'parentUrl'
            );
            let redirectURI = `${parentUrl}/`;
            let referrer = queryObj.referrer || '';
            if (referrer.includes('http')) {
              redirectURI = referrer;
            } else {
              if (referrer.indexOf('/') === 0) {
                referrer = referrer.slice(1);
              }
              redirectURI = `${redirectURI}${referrer}`;
            }
            if (viewSiteAs == 'desktop') {
              let { location: { search = '', pathname: source = '' } = {} } = this.props;
              if (source == '/login') {
                window.location = redirectURI;
              } else {
                // close modal
                this.props.hideModal('sign-in-up');
              }
              // window.location.reload();
            } else {
              window.location = redirectURI;
            }
          }
          if (this.props.errorStatus == 400) {
            let erMsg = 'Invalid OTP';
            if (this.props.errMsg.includes('exceeded')) {
              erMsg = 'You have exceeded maximum OTP attempts, Please try again after some time.';
            }
            if (this.props.errMsg.includes('locked')) {
              erMsg = this.props.errMsg;
            }
            let gaErr = `Error - ${erMsg}`;
            ga('send', {
              eventCategory: 'Sign Up',
              eventAction: 'Welcome to AJIO',
              eventLabel: gaErr
            });
            this.setState({
              errorMsg: this.props.errMsg,
              showTimer: false
            });
            gtmEventPush({
              page_name: 'signup - otp screen',
              page_type: 'user account screen',
              event: 'user_account_interactions',
              category: 'user accounts interactions',
              action: 'Login method - OTP',
              label: 'Start shopping - failure'
            });
          } else {
            this.setState({ errorMsg: this.props.errMsg });
          }
        } else {
          gtmEventPush({
            page_name: 'signup - otp screen',
            page_type: 'user account screen',
            event: 'formError',
            category: 'formError',
            action: 'sign up OTP form',
            label: 'Please enter a valid OTP'
          });
          ga('send', {
            eventCategory: 'Sign Up',
            eventAction: "Glad you're back",
            eventLabel: 'Start Shopping - Failure'
          });
          this.setState({
            errorMsg: 'Please enter a valid OTP',
            showTimer: true
          });
        }
      } else {
        this.setState({
          errorMsg: this.props.errMsg,
          showTimer: false
        });
      }
    });
  }

  showPwd(toggleState) {
    let inputPwd = document.getElementById('pwdInput');
    if (toggleState) {
      if (inputPwd.type == 'password') {
        inputPwd.type = 'text';
      }
    } else {
      inputPwd.type = 'password';
    }
  }

  getOTPforAuthCB = otpValue => {
    this.setState({ otpEntered: otpValue });
  };

  resendOTPforAuthCB = (
    signUpObj,
    isResendOTP,
    enableRestorePhoneNumber,
    signupEmailExistMessage,
    signupRestoreMessage
  ) => {
    console.log('RESENDDDDDDDDDDDD');
    this.handleSendOTPSubmit(
      event,
      signUpObj,
      this.props.viewSiteAs,
      isResendOTP,
      enableRestorePhoneNumber,
      signupEmailExistMessage,
      signupRestoreMessage
    );
    this.setState({
      errorMsg: '',
      showTimer: true
    });
  };

  updateEmail = e => {
    this.setState({ userEmail: e.target.value });
    e.target.value && this.isRilUser(e.target.value);
  };

  isRilUser = debounce(value => {
    const { flags = {}, availableDomains } = this.props;
    const isDomainlRil = isRilDomain(availableDomains, value);
    this.setState({ showRilEmailMsg: isDomainlRil });
  }, 1000);

  handleRedirectForRestorePhone = () => {
    const { history = {} } = this.props;
    this.props.hideModal('sign-in-up');
    history.push({
      pathname: 'restore-phonenumber',
      search: '?utm_source=restore_your_mob&utm_medium=Web&utm_campaign=common_login_signup_screen',
      state: {
        usernameObj: {
          emailId: this.state.userEmail
        }
      }
    });
    gtmEventPush({
      page_name: 'login/signup screen',
      page_type: 'login/signup',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'restore phone number - click'
    });
  };

  render() {
    let {
      location: { search = '' } = {},
      viewSiteAs = '',
      userCred = '',
      history = {},
      flags = {},
      newDesign = false,
      newDesignLuxe,
      ajioMassEmailIdOptional,
      isUaas,
      fraudReductionForEmployeeCouponsFlag,
      fraudReductionForEmpCouponsLabels,
      availableDomains
    } = this.props;
    const enableRestorePhoneNumber = getEnableRestorePhoneNumber(flags);
    const signupRestoreMessageFromFirebase = getRemovalLoginPasswordJson(flags);
    const signupRestoreMessage =
      signupRestoreMessageFromFirebase?.signup_restore_phone_number_message ||
      'Email address is already linked to another account. Use a different email address or restore phone number.';
    const signupEmailExistMessage = getAccountCheckApiErrorMsgForSignup(flags);
    // let userAccCredData = decodeURIComponent(readCookie("uI"));
    const isGPay = sessionStorage.getItem('gpay') === 'true';
    const isPhonePe = sessionStorage.getItem('phonepe') === 'true' || isPhoneUserAgent();
    let userAccCredData;
    if (readCookie('uI')) {
      userAccCredData = decodeURIComponent(readCookie('uI'));
    } else {
      userAccCredData = userCred;
    }
    const isEmailSignUp =
      userAccCredData &&
      this.state.userEmail &&
      isRilDomain(availableDomains, this.state.userEmail);
    var signUpObj = {};
    let mobileNumber = this.state.userEmail
      ? this.state.userEmail.toLowerCase()
      : this.state.userMobile;
    signUpObj = {
      firstName: this.state.userName,
      login: this.state.userEmail.toLowerCase(),
      // password: this.state.userPwd,
      genderType: this.state.userGender,
      mobileNumber: this.state.userMobile
    };
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags)) {
      signUpObj = { ...signUpObj, rilFnlRegisterReferralCode: this.state.inviteCode };
    }
    let otpMsg = 'OTP will be sent to your number for verification.';
    if (this.state.showOTPComponent) {
      return (
        <div>
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} signup-form`}
            onSubmit={e => this.handleOTPAuthSubmit(e, signUpObj, viewSiteAs)}
            data-ga-event-category="Sign Up"
            data-ga-event-action="Welcome to AJIO"
            data-ga-event-label="Screen Launch"
          >
            <div>
              {this.renderReferralHeader('signupOtp', newDesignLuxe)}
              <h2 className="login-form-inputs user-cred-info">Please enter OTP sent to</h2>
              <div className="login-form-inputs masked-cred">{this.state.userMobile}</div>
              <OTPComponent
                getOTP={this.getOTPforAuthCB}
                resendOTP={() =>
                  this.resendOTPforAuthCB(
                    signUpObj,
                    true,
                    enableRestorePhoneNumber,
                    signupEmailExistMessage,
                    signupRestoreMessage
                  )
                }
                viewSiteAs={viewSiteAs}
                showTimer={this.state.showTimer}
                errorMsg={this.state.errorMsg}
                newDesignLuxe={newDesignLuxe}
                pageType="signup"
              />
              <div>
                <input
                  type="submit"
                  className="login-form-inputs login-btn numberverifysubmit"
                  value="START SHOPPING"
                  onClick={() => {
                    gtmEventPush({
                      page_name: 'signup - otp screen',
                      page_type: 'user account screen',
                      event: 'user_account_interactions',
                      category: 'user account interactions',
                      action: 'Start shopping'
                    });
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      );
    }
    //  else if ( this.state.pwdComponent) {
    //   return (
    //     <OldPassword
    //       viewSiteAs={viewSiteAs}
    //       queryString={search}
    //       displayEmail={this.props.displayEmail}
    //       existingUserSignUp={this.state.existingUserSignUp}
    //       userAccObj={this.state.userAccObj}
    //     />
    //   );
    // }
    else if (this.state.backToAuth) {
      return <SignInComponent viewSiteAs={viewSiteAs} queryString={search} />;
    } else {
      let { userEmail = '', userMobile = '' } = this.state || {};
      return (
        <div>
          {/* {this.props.errorStatus=="400" ? <div>An account already exists with this email/mobile number</div> : <div>FALSE</div> } */}
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} signup-form`}
            noValidate
            onSubmit={e =>
              this.handleSendOTPSubmit(
                e,
                signUpObj,
                viewSiteAs,
                false,
                enableRestorePhoneNumber,
                signupEmailExistMessage,
                signupRestoreMessage
              )
            }
            data-ga-event-category="Sign Up"
            data-ga-event-action="Welcome to AJIO"
            data-ga-event-label="Screen Launch"
          >
            {this.renderReferralHeader('', newDesignLuxe)}
            {!(isGPay || isPhonePe) && !newDesign && (
              <div />
              // <SocialAccount setSocialAccExists={this.props.setSocialAccExists} />
            )}

            <h2 className="context-header" tabIndex={0}>Please set up your account</h2>
            <div className="login-form-inputs user-cred-info">
              <span aria-label={userAccCredData}>{userAccCredData}</span>
              <span
                className={
                  viewSiteAs == 'desktop' ? 'input-extra-options-desktop' : 'input-extra-options'
                }
                id="editBtn"
                tabIndex={0}
                role="button"
                onClick={() => {
                  gtmEventPush({
                    event: 'link_click',
                    screen_type: `Sign up`,
                    link_text: `Edit`,
                    user_login_step: 2,
                    page_type: 'Sign up',
                    page_name: 'login/signup screen'
                  });
                  gtmEventPush({
                    page_name: 'login/signup screen',
                    page_type: 'user account screen',
                    event: 'user_account_interactions',
                    category: 'user account interactions',
                    action: 'Edit mobile number'
                  });
                  if (viewSiteAs == 'desktop') {
                    this.setState({
                      backToAuth: true
                    });
                    this.props.updateState({
                      backClicked: true,
                      userData: userEmail || userMobile
                    });
                  } else {
                    history.push({
                      pathname: '/login',
                      state: {
                        userData: userAccCredData
                      }
                    });
                  }
                }}
              >
                Edit
              </span>
              {this.state.inputPlaceHolder == 'Email' ? (
                <div className="mob-verify-otp"> {otpMsg} </div>
              ) : (
                fraudReductionForEmployeeCouponsFlag &&
                isUaas &&
                isEmailSignUp && (
                  <EmailVerify
                    sourceType="EDUCATE"
                    ctaLabel={fraudReductionForEmpCouponsLabels?.verifyRilEmpTxt}
                  />
                )
              )}
            </div>

            <fieldset className="genderOptions" onChange={e => { this.setState({ userGender: e.target.value }); }} aria-describedby='gender-error'>
              <legend className="sr-only">Gender</legend>
              Gender{newDesignLuxe ? '' : ':'}
              <label className="gender-opt">
                <input
                  className="radio-gender"
                  type="radio"
                  id="gender1"
                  name="gender"
                  value="Female"
                  tabIndex={0}
                />
                <span className="ic-Radio-Buton-Of default-radio radio-text" />
                Female{' '}
              </label>
              <label className="gender-opt">
                <input
                  className="radio-gender"
                  type="radio"
                  id="gender2"
                  name="gender"
                  value="Male"
                  tabIndex={0}
                />
                <span className="ic-Radio-Buton-Of default-radio radio-text" />
                Male{' '}
              </label>
            </fieldset>
            <div id="gender-error" className="error-msg" >
              {this.state.errGender}
            </div>

            {newDesignLuxe ? (
              <FloatingInput
                error={this.state.errName}
                type="text"
                name="user-name"
                className="login-form-inputs"
                floatingText="Name"
                placeholder="  "
                // autoFocus
                size="32"
                maxLength="64"
                value={this.state.userName}
                onChange={e => this.setState({ userName: e.target.value })}
              />
            ) : (
              ''
            )}

            {newDesignLuxe ? (
              ' '
            ) : (
              <div>
                <input
                  type="text"
                  name="user-name"
                  className="login-form-inputs"
                  placeholder={ajioMassEmailIdOptional ? 'Name*' : 'Name'}
                    // autoFocus
                  size="32"
                  maxLength="64"
                  value={this.state.userName}
                  aria-describedby="user-name-error"
                  onChange={e => this.setState({ userName: e.target.value })}
                    autoComplete="name"
                    aria-label='Enter First /middle name/ last name'
                />
              </div>
            )}

            <div id="user-name-error" className="error-msg" >
              {this.state.errName}
            </div>

            {newDesignLuxe ? (
              <FloatingInput
                error={this.state.errEmail || this.state.errMob}
                type={this.state.inputSignUpType}
                name="email-mob"
                className="login-form-inputs"
                floatingText={this.state.inputPlaceHolder}
                placeholder="  "
                size="32"
                value={
                  this.state.inputSignUpType === 'text'
                    ? this.state.userMobile
                    : this.state.userEmail
                }
                onChange={e => {
                  this.state.inputSignUpType === 'text'
                    ? this.setState({ userMobile: e.target.value })
                    : // : this.setState({ userEmail: e.target.value });
                    this.updateEmail(e);
                }}
              />
            ) : (
              ''
            )}

            {newDesignLuxe ? (
              ''
            ) : (
              <div>
                <input
                  type={this.state.inputSignUpType}
                  name="email-mob"
                  className="login-form-inputs"
                  placeholder={this.state.inputPlaceHolder}
                  size="32"
                  value={
                    this.state.inputSignUpType === 'text'
                      ? this.state.userMobile
                      : this.state.userEmail
                  }
                  onChange={e => {
                    this.state.inputSignUpType === 'text'
                      ? this.setState({ userMobile: e.target.value })
                      : // : this.setState({ userEmail: e.target.value });
                      this.updateEmail(e);
                  }}
                    aria-label="Enter email as name@domain.com"
                    autoComplete="email"
                    aria-describedby="email-error"
                />
                {enableRestorePhoneNumber && this.state.pwdComponent && (
                  <div className="email-already-exist-for-fraud">
                    <div className="email-already-exist-text-for-fraud">{signupRestoreMessage}</div>
                    <input
                      type="submit"
                      className="restore-phone-btn"
                      value="Restore Phone Number"
                      onClick={this.handleRedirectForRestorePhone}
                    />
                  </div>
                )}
                {!enableRestorePhoneNumber && this.state.pwdComponent && (
                  <div className="email-already-exist">
                    <div className="email-already-exist-text">{signupEmailExistMessage}</div>
                  </div>
                )}
              </div>
            )}

            {this.state.inputSignUpType === 'email' ? (
              <div id="email-error" className="error-msg" >
                {this.state.errEmail}
              </div>
            ) : (
              <div id="error-msg" className="error-msg" >
                {this.state.errMob}
              </div>
            )}
            {!newDesignLuxe && this.state.inputPlaceHolder == 'Mobile' ? (
              <div className="mob-verify-otp"> {otpMsg} </div>
            ) : (
              fraudReductionForEmployeeCouponsFlag &&
              isUaas &&
              this.state.showRilEmailMsg && (
                <EmailVerify
                  ctaLabel={fraudReductionForEmpCouponsLabels?.verifyRilEmpTxt}
                  sourceType="EDUCATE"
                />
              )
            )}
            {!newDesign && (
              <>
                {newDesignLuxe ? (
                  <div>
                    <FloatingInput
                      type="password"
                      error={this.state.errPwd}
                      name="pwd"
                      className={`login-form-inputs ${
                        this.state.showPwdClicked ? 'show-pwd-otp' : ''
                        }`}
                      floatingText="Password"
                      placeholder="  "
                      size="32"
                      id="pwdInput"
                      maxLength="20"
                      value={this.state.userPwd}
                      onChange={e =>
                        this.setState({
                          userPwd: e.target.value,
                          showTxt: true
                        })
                      }
                    />

                    {this.state.showTxt ? (
                      <span
                        className="show-pwd"
                        onClick={e => {
                          let toggleState = !this.state.showPwdClicked;
                          this.setState({
                            showPwdClicked: toggleState,
                            hideTxt: !this.state.hideTxt
                          });
                          this.showPwd(toggleState);
                        }}
                      >
                        {!this.state.hideTxt ? 'Show' : 'Hide'}
                      </span>
                    ) : null}
                  </div>
                ) : (
                  ''
                )}

                {newDesignLuxe ? '' : null
                  // !enableRestorePhoneNumber && (
                  //     <div>
                  //       <input
                  //         type="password"
                  //         name="pwd"
                  //         className={`login-form-inputs ${
                  //           this.state.showPwdClicked ? 'show-pwd-otp' : ''
                  //         }`}
                  //         placeholder={ajioMassEmailIdOptional ? 'Password*' : 'Password'}
                  //         size="32"
                  //         id="pwdInput"
                  //         maxLength="20"
                  //         value={this.state.userPwd}
                  //         onChange={e =>
                  //           this.setState({
                  //             userPwd: e.target.value,
                  //             showTxt: true
                  //           })
                  //         }
                  //       />
                  //       {this.state.showTxt ? (
                  //         <span
                  //           className="show-pwd"
                  //           onClick={e => {
                  //             gtmEventPush({
                  //               page_name: 'signup screen',
                  //               page_type: 'user account screen',
                  //               event: 'user_account_interactions',
                  //               category: 'user account interactions',
                  //               action: !this.state.hideTxt ? 'Show Password' : 'Hide Password'
                  //             });
                  //             let toggleState = !this.state.showPwdClicked;
                  //             this.setState({
                  //               showPwdClicked: toggleState,
                  //               hideTxt: !this.state.hideTxt
                  //             });
                  //             this.showPwd(toggleState);
                  //           }}
                  //         >
                  //           {!this.state.hideTxt ? 'Show' : 'Hide'}
                  //         </span>
                  //       ) : null}
                  //     </div>
                  //   )
                }

                {/* {!enableRestorePhoneNumber && (
                  <div id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errPwd && !this.state.errPwd.includes('code')
                      ? this.state.errPwd
                      : ''}
                  </div>
                )} */}
              </>
            )}

            {this.renderInviteCodeInput()}

            <div className="btn-action-txt">
              <label>
                <input
                  onChange={() => {}}
                  onClick={() => {
                    this.setState({
                      agreed: !this.state.agreed
                    });
                  }}
                  id="tncCheckbox"
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.agreed}
                  aria-describedby="tnc-error"
                />
                <span class="custom-outline"></span>
                <span className="tnc"> By Signing Up, I agree to </span>
                <a
                  data-ga-event-category="Login"
                  data-ga-event-action="Welcome to AJIO"
                  data-ga-event-label="T&C Click"
                  href="https://www.ajio.com/help/termsAndCondition"
                >
                  Terms and Conditions
                </a>
                .
              </label>
            </div>
            <div id="tnc-error" className="error-msg" >
              {this.state.errChkbox}
            </div>
            <div className={newDesignLuxe ? 'signupSubmitButton' : ''}>
              <input
                type="submit"
                className="login-form-inputs login-btn"
                value={this.state.pwdComponent ? 'GET OTP' : 'SEND OTP'}
                onClick={() => {
                  localStorage.setItem('LoginModelType', 'signup - otp screen');
                  gtmEventPush({
                    page_name: 'login/signup screen',
                    page_type: 'user account screen',
                    event: 'user_account_interactions',
                    category: 'user account interactions',
                    action: 'Send OTP'
                  });
                }}
              />
            </div>
          </form>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signupSendOTP: (formData, callback) => dispatch(signupSendOTP(formData, callback)),
    signupAuthUser: (formData, callback) => {
      dispatch(signupAuthUser(formData, callback));
    },
    accountCheck: (formInput, callback) => {
      dispatch(accountCheck(formInput, callback));
    },
    login: (formData, callback) => {
      dispatch(login(formData, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setReferrerDetailsObj: name => {
      dispatch(setReferrerDetails(name));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const {
    signInReducer = {},
    signUpReducer = {},
    httpError = {},
    referAndEarn = {},
    flags = {}
  } = state;
  const { error = {} } = httpError;
  const {
    success = false,
    validUser = false,
    displayEmail = false,
    maskedEmailId = '',
    maskedMobileNumber = ''
  } = signInReducer;
  const { statusCode = 0, authSuccess = 0, message: otpErrMsg = '' } = signUpReducer;
  const {
    referrerDetails = {},
    refereeIncentive = 0,
    refereeIncentiveExpiresIn = {}
  } = referAndEarn;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const ajioMassEmailIdOptional =
    getAjioMassEmailIdOptionalWeb(flags) &&
    storeName === STREET_STORE &&
    getFeatureVariant('email-is-optional') !== '0';

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    accCheck: success,
    maskedEmailId,
    maskedMobileNumber,
    displayEmail,
    validUser,
    statusCode,
    authSuccess,
    errorStatus: error.statusCode,
    otpErrMsg,
    errMsg: error?.message || '',
    refereeIncentive,
    referrerDetails,
    flags,
    refereeIncentiveExpiresIn,
    newDesignLuxe,
    storeName,
    ajioMassEmailIdOptional,
    isUaas: getUaas(state),
    fraudReductionForEmployeeCouponsFlag: getFraudReductionForEmployeeCouponsFlag(state),
    fraudReductionForEmpCouponsLabels: getFraudReductionForEmpCouponsLabels(state),
    availableDomains: getAvailableDomainsFlag(state)
  };
};

export default SignUpComponent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpComponent)
);
